<template>
  <div class="main-page page-mediaion-case">
    <Menu
      title="司法行政案例"
      :home="true"
    />
    <div class="main-block">
      <div class="left-nav">
        <div
          :class="['item','txtone',index==choose?'active':'']"
          v-for="(navitem ,index) in casetag"
          @click="getData(navitem,index)"
          :key="'key-nav'+index"
        >
          {{navitem}}
        </div>
      </div>
      <div class="right-con">
        <div
          class="list-box"
          v-infinite-scroll="loadmore"
          :infinite-scroll-disabled="loading"
          infinite-scroll-distance="10"
        >
          <div class="list-title">
            {{choosename}} > 全部
          </div>
          <div
            class="item"
            v-for="(item,index) in list"
            @click="getDetail(item)"
            :key="'key-d'+index"
          >
            <div class="imgs">
              <img
                src="/img/ui/yasfcase.png"
                width="43"
                alt=""
              >
            </div>
            <div class="intro ">
              <div class="title txtone">
                {{item.title}}
              </div>
              <div class="desc">
                时间：{{item.publish}}
              </div>
            </div>
          </div>
          <div class="foot">
            <div
              class="tip"
              v-if="loadover"
            >已经全部加载</div>
            <div
              class="more-link"
              v-else
            >
              加载更多
            </div>
          </div>
        </div>
      </div>
    </div>
    <Rightslide
      v-model="slide"
      v-if="slide.show"
      @getClose="getClose"
    >
      <template slot="content">
        <div class="title">
          {{article.title}}
        </div>
        <div
          class="detail"
          v-html="article.content"
        >
        </div>
      </template>
    </Rightslide>
  </div>
</template>
<script>
import Menu from '../../components/Menu'
import Rightslide from '../../components/RightSlide'
import api from '../../datas/js/api.js'
import { SIFA_CASE } from '../../datas/constants/statistics.js'
export default {
  components: {
    Menu,
    Rightslide
  },
  data () {
    return {
      title: '司法行政案例',
      list: [],
      casetag: [
        '监狱工作',
        '戒毒工作',
        '社区矫正工作',
        '法治宣传教育工作',
        '律师工作',
        '公证工作',
        '法律援助工作',
        '人民调解工作',
        '司法考试工作',
        '司法鉴定工作',
        '法制工作'
      ],
      choose: 0,
      page: 1,
      pageSize: 0,
      choosename: '',
      article: '',
      slide: {
        show: false
      },
      loading: false,
      loadover: false
    }
  },
  methods: {
    getClose () {
      this.slide.show = false
    },
    async getData (item, index) {
      this.loadover = false
      this.choose = index
      this.page = 1
      this.pageSize = 0
      $('.list-box').scrollTop(0, 2000) // eslint-disable-line
      this.getList()
    },
    async getDetail (item) {
      const { status, result, msg } = await this.$get(api.judicialcasedetail + item.id + '/', this)
      if (!status) {
        console.log(msg)
        return
      }
      this.slide.show = true
      this.article = result
    },
    async getList () {
      this.choosename = this.casetag[this.choose]
      const { result, status, msg } = await this.$get(`${api.judicialcase}530000&category_lv1=${this.choosename}&page=1`, this)
      if (status === 1) {
        this.list = result.data
        this.pageSize = result.num_pages
      } else {
        console.log(msg)
      }
    },
    loadmore () {
      if (this.loadover) {
        return
      }
      this.loading = true
      setTimeout(async () => {
        this.page = this.page + 1
        this.choosename = this.casetag[this.choose]
        const { result, status, msg } = await this.$get(`${api.judicialcase}530000&category_lv1=${this.choosename}&page=${this.page}`, this)
        console.log(this.pageSize, this.page, 'page')
        if (this.page === this.pageSize) {
          this.loadover = true
        }
        if (status === 1) {
          this.list = this.list.concat(result.data)
        } else {
          console.log(msg)
        }
        this.loading = false
      }, 1000)
    }
  },
  async mounted () {
    this.$root.getStatistics(SIFA_CASE)
    this.getList()
  }
}
</script>
<style lang="stylus">
.page-mediaion-case
  .main-block
    flex 1
    overflow hidden
    padding 0.3rem 1.6rem
    display flex
    .left-nav
      width 3.2rem
      height 100%
      margin-right 0.4rem
      overflow-y scroll
      flex-shrink 0
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .item
        height 0.8rem
        line-height 0.8rem
        font-size 0.26rem
        color rgba(255, 255, 255, 0.9)
        padding 0 0.35rem
        background-color rgba(255, 255, 255, 0.2)
        border-radius 0.08rem
        border solid 1px rgba(255, 255, 255, 0.2)
        margin-bottom 0.05rem
        &.active
          background #f29530
    .right-con
      display flex
      flex 1
      height 100%
    .list-box
      width 100%
      margin-right 0.2rem
      border-radius 0.1rem
      background #fff
      overflow-y scroll
      -webkit-overflow-scrolling touch
      &::-webkit-scrollbar
        display none
        width 0 !important
      .list-title
        height 0.74rem
        border-radius 0.1rem 0.1rem 0 0
        font-size 0.24rem
        line-height 0.74rem
        background-color #fff
        padding 0 0.34rem
        border-bottom 1px solid #e5e5e5
        color #333333
      .foot
        padding 0.25rem 0
        font-size 0.2rem
        text-align center
        color #999
      .item
        position relative
        background #fff
        padding 0.25rem 0.35rem
        box-sizing border-box
        display flex
        &:after
          content ''
          position absolute
          bottom 0
          left 0.35rem
          right 0.35rem
          border-bottom 1px solid #e5e5e5
        &:last-child
          border-radius 0 0 0.1rem 0.1rem
        &:active
          background #f7f7f7
        .imgs
          width 0.9rem
          height 0.9rem
          border-radius 50%
          margin-right 0.16rem
          background-color #edf3ff
          text-align center
          line-height 0.9rem
          flex-shrink 0
        .intro
          padding-right 0.3rem
          display flex
          flex-direction column
          justify-content center
          overflow hidden
          span
            color #ccc
            padding 0 0.1rem
        .title
          font-size 0.24rem
          color #333333
          line-height 1
          width 100%
          margin-bottom 0.2rem
        .desc
          font-size 0.18rem
          color #666666
          line-height 1
  .slide-box
    .slide-box-content
      width 8rem
      padding 0 0.4rem
      .title
        font-size 0.32rem
        line-height 1.4
        font-weight 600
        padding 0.6rem 0 0.2rem 0
      .detail
        line-height 1.8
        font-size 0.2rem
        img
          max-width 100%
        p
          margin 1em 0
  .footerslide
    .btns
      width 8rem
</style>
